// extracted by mini-css-extract-plugin
export default {"products":"Product_products__oMe+H","products_container":"Product_products_container__RRdFM"};